import { styled } from '@mui/material/styles';
import { Typography } from '../Typography';

export const SelectLabelStyled = styled(Typography)`
  margin-left: 15px;
`;
